import SignupPageContent from "@/app/signup/page";

export default function SignupPage() {
  return <SignupPageContent />;
}
